"use strict";

/**
 * @module Services.GatewayControl
 */
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GatewayClientInvokeOperationRequest = void 0;
var base_gateway_client_request_1 = require("./../../../services/gateway-control/base-gateway-client-request");
var gateway_request_type_1 = require("./../../../services/gateway-control/gateway-request-type");
/**
 * Data type for a GATEWAY_CLIENT_REQUEST invoke operation request.
 */
var GatewayClientInvokeOperationRequest = /** @class */function (_super) {
  __extends(GatewayClientInvokeOperationRequest, _super);
  /**
   * Create a new GatewayClientInvokeOperationRequest instance
   *
   * @param sessionId  the gateway client session id
   * @param operationName  the name of the operation to invoke
   * @param input  optional input data in the form of a JSON string
   */
  function GatewayClientInvokeOperationRequest(sessionId, operationName, input) {
    var _this = _super.call(this, sessionId) || this;
    _this.type = gateway_request_type_1.GatewayRequestType.INVOKE_OPERATION;
    _this.operationName = operationName;
    _this.input = input;
    return _this;
  }
  return GatewayClientInvokeOperationRequest;
}(base_gateway_client_request_1.BaseGatewayClientRequest);
exports.GatewayClientInvokeOperationRequest = GatewayClientInvokeOperationRequest;